import styled from 'styled-components';
import { Cloud, Database, Server, BarChart, Cog, Laptop } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import image1 from '../images/img2.png';
import image2 from '../images/bg10.png';
import logo from '../images/total.png';
import logo1 from '../images/lv.png';
import logo2 from '../images/allianz.png';
import logo3 from '../images/mr.png';
import logo4 from '../images/eur.png';
import logo5 from '../images/ft.png';


const services = [
  {
    icon: <Cloud size={48} />,
    title: "Conseil en Cloud Computing",
    description: "Solutions cloud sur mesure pour votre entreprise"
  },
  {
    icon: <Database size={48} />,
    title: "Ingénierie des Données",
    description: "Gestion et analyse avancée des données"
  },
  {
    icon: <Server size={48} />,
    title: "Architecture Data",
    description: "Infrastructure de données robuste et évolutive"
  },
  {
    icon: <BarChart size={48} />,
    title: "Gouvernance des Données",
    description: "Qualité et conformité des données"
  },
  {
    icon: <Cog size={48} />,
    title: "Automatisation",
    description: "Optimisation des processus métier"
  },
  {
    icon: <Laptop size={48} />,
    title: "Accompagnement en Méthodes Agiles",
    description: "Transformation digitale agile"
  }
];


const Home = () => {
  const navigate = useNavigate();

  return (
    <HomeContainer>
      <HeroSection>
      <h1>L'Excellence Numérique<br />au Service de votre Réussite</h1>
      <p>Accélérez votre transformation digitale avec notre expertise</p>
        <ImageSection>
          <img src={image1} alt="Illustration technologique" />
        </ImageSection>
      </HeroSection>

      {/*Vision en Valeur */}
      <VisionSection>
      <h2>L'Intelligence des Données,<br />Moteur de Performance</h2>
 <p>
   Transformez vos données en avantage concurrentiel avec DataVision Solutions.
   Notre expertise en analyse avancée et cloud computing propulse 
   votre croissance par des solutions innovantes et évolutives.
 </p>
        <ButtonGroup>
          <Button onClick={() => navigate('/about')} >En Savoir Plus</Button>
          <SecondaryButton onClick={() => navigate('/contact')} >Contactez-nous</SecondaryButton>
        </ButtonGroup>
      </VisionSection>

      {/*Nos services */}
      <ServicesSection>
        <SectionTitle>Nos Services</SectionTitle>
        <h2>Technologies Innovantes<br />pour votre Succès</h2>
        <p>Une palette complète de services technologiques conçus pour répondre aux défis de demain</p>

        <ServicesGrid>
          {services.map((service, index) => (
            <ServiceCard key={index}>
              {service.icon}
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </ServiceCard>
          ))}
        </ServicesGrid>

        <Button onClick={() => navigate('/services')} style={{ marginTop: '2rem' }}>Voir tous nos services</Button>
      </ServicesSection>

      {/* Formations  */}
      <FormationSection>
        <FormationContent>
          <SectionTitle>Formation</SectionTitle>
          <h2>Développez les Talents<br />de Demain</h2>
          <p>
     Montez en compétences avec nos programmes spécialisés en Data Science,
     Cloud Computing et DevOps. Des formations conçues pour les professionnels
     qui veulent maîtriser les technologies d'avenir.
   </p>

          <DashboardImage>
            <img src={image2} alt="Dashboard Analytics" />
          </DashboardImage>

          <Button onClick={() => navigate('/formation')}>
          Explorer nos formations
          </Button>
        </FormationContent>
      </FormationSection>

      {/* Logo */}
      <PartnersSection>
        <LogoGrid>
          <img src={logo3} alt="Mairie de Paris" />
          <img src={logo1} alt="Louis Vuitton" />
          <img src={logo2} alt="Allianz" />
          <img src={logo4}  alt="Eurostat" />
          <img src={logo} alt="TotalEnergies" />
          <img  src={logo5} alt="France Travail" />
        </LogoGrid>
      </PartnersSection>

      {/* Transformez vos */}
      <VisionSection>
        <h2>Transformez vos<br />données en opportunités</h2>
        <ButtonGroup>
          <Button onClick={() => navigate('/contact')}  >Contactez-nous</Button>
          <SecondaryButton>Entrons Rendez-vous</SecondaryButton>
        </ButtonGroup>
      </VisionSection>
    </HomeContainer>

  );
};

export default Home;


export const Button = styled.button`
  background: #2563eb;
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 1rem;
  transition: background 0.3s ease;

  &:hover {
    background: #1d4ed8;
  }
`;

const HomeContainer = styled.div`
  text-align: center;
  min-height: 100vh;
  display: flex;

  flex-direction: column;
`;

const HeroSection = styled.section`
  padding: 5rem 1rem;
  background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,40,0.1) 100%);

  h1 {
    font-size: clamp(2.5rem, 5vw, 4rem);
    margin-bottom: 1rem;
    line-height: 1.2;
  }

  p {
    color: #cbd5e1;
    font-size: 1.25rem;
     line-height: 1.6;
    margin-bottom: 2rem;
  }
`;

const ImageSection = styled.div`
  position: relative;
  max-width: 800px;
  margin: 2rem auto;
  
  img {
    width: 100%;
    height: auto;
  }
`;

const VisionSection = styled.section`
  padding: 4rem 1rem;
  background: rgba(0, 0, 50, 0.1);

  h2 {
    font-size: clamp(2rem, 4vw, 3rem);
    margin-bottom: 1rem;
  }

  p {
    color: #94a3b8;
    max-width: 800px;
    margin: 0 auto 2rem;
    line-height: 1.6;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
   margin-bottom: 4rem;
`;

const SecondaryButton = styled(Button)`
  background: transparent;
  border: 1px solid #2563eb;
  
  &:hover {
    background: rgba(37, 99, 235, 0.1);
  }
`;

const ServicesSection = styled.section`
  padding: 4rem 1rem;
  text-align: center;

  h2 {
    font-size: 2rem;
    margin-bottom: 0.5rem;
  }

  p {
    color: #94a3b8;
    margin-bottom: 3rem;
     line-height: 1.6;
  }
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
`;

const ServiceCard = styled.div`
  background: rgba(30, 58, 138, 0.3);
  border-radius: 1rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  backdrop-filter: blur(8px);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }

  svg {
    color: #60a5fa;
    margin-bottom: 1rem;
  }

  h3 {
    margin-bottom: 0.5rem;
    color: white;
  }

  p {
    color: #94a3b8;
    font-size: 0.9rem;
     line-height: 1.6;
  }
`;


const FormationSection = styled.section`
  padding: 4rem 1rem;
  text-align: center;
  position: relative;
  overflow: hidden;
`;

const FormationContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;

  h2 {
    font-size: 2rem;
    margin-bottom: 1.5rem;
  }

  p {
    color: #94a3b8;
    margin-bottom: 2rem;
    max-width: 800px;
    margin: 0 auto 2rem;
     line-height: 1.6;
  }
`;

const DashboardImage = styled.div`
  max-width: 500px;
  margin: 2rem auto;
  position: relative;

  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
  }
`;

const SectionTitle = styled.div`
 color: #60a5fa;
 font-weight: 600;
 margin-bottom: 1rem;
 text-transform: uppercase;
 letter-spacing: 1px;
`;

const PartnersSection = styled.div`
  padding: 4rem 2rem;

`;

const LogoGrid = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;

  img {
    height: 55px;
    width: auto;
    opacity: 0.7;
    filter: brightness(0) invert(1);
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    justify-content: center;
    gap: 3rem;
    
    img {
      height: 35px;
    }
  }
`;